import { useTranslation } from 'react-i18next';
import { useLog } from 'components/Navbar/Desktop/useNavBarClickLog';
import arrowLeft from 'public/static/images/arrow-left.png';

interface BackToSearchProps {
  onClick: () => void;
  showEnhancement?: boolean;
}

export function BackToSearch({ onClick, showEnhancement }: BackToSearchProps): JSX.Element {
  const { t } = useTranslation();
  const log = useLog();

  return (
    <button
      className="back-button-container"
      role="button"
      onClick={(): void => {
        log('back_to_search_tap');
        onClick();
      }}
    >
      <div data-testid="back-icon" className="back-icon" />
      <a className="back-button" suppressHydrationWarning={true}>
        {showEnhancement ? t('vdp.viewMoreCars') : t('vdp.backToSearch')}
      </a>
      <style jsx>{`
        .back-button-container {
          display: flex;
          flex-direction: row;
          cursor: pointer;
          background: none;
          border: none;
          padding: 0;
          color: inherit;
          font: inherit;
          outline: inherit;
        }

        .back-icon {
          width: 15px;
          height: 21px;
          background-image: url('${arrowLeft}');
          background-size: 12px 21px;
          background-repeat: no-repeat;
          margin-right: 2px;
        }
      `}</style>
    </button>
  );
}
